import { useEffect, useRef, useState } from 'react';
import { USER_MSG_PREFIX, REMATCH_MSG_PREFIX } from './config/config';
import { sendPhotonEvent } from './utils/photon/client';
import classNames from 'classnames';
import { IS_LOCAL } from './config/env';
import './Logs.scss';


const msgClassnames = (txt) => {
  const config = {};
  if (txt.startsWith(USER_MSG_PREFIX)) {
    config['user-msg'] = true;
  } else if (txt.startsWith(REMATCH_MSG_PREFIX)) {
    config['rematch-msg'] = true;
  } else {
    config['log-entry'] = true;
  }
  return classNames(config);
};

const formattedMsg = (msg = '') => msg
  .replace(USER_MSG_PREFIX, '') // players msgs
  .replace(REMATCH_MSG_PREFIX, '') // rematch msg


export const Logs = ({ uiMessages, loggedInUser, appData, addMsg }) => {
  const logsRef = useRef(null);
  const [inputValue, setInputValue] = useState('');

  // BUGGY: remove ugly AF hack @@@@@@@@@@@
  // BUGGY: remove ugly AF hack @@@@@@@@@@@
  // add to appState -> canChat
  const opponentMissing = useRef(true);

  useEffect(() => {
    if (!appData.waitingOpponent) opponentMissing.current = false;
  }, [appData.waitingOpponent])

  useEffect(() => {
    if (logsRef.current) {
      logsRef.current.scrollTop = logsRef.current.scrollHeight;
    }
  }, [uiMessages]);

  const sendMessage = () => {
    if (!IS_LOCAL) { // @@@@@@@@@@@@@@@@@@@
      alert('coming soon!');
      return;
    }
    const msg = inputValue.trim();
    if (msg) {
      const fullMsg = `${USER_MSG_PREFIX}${loggedInUser}: ${msg}`;
      // TODO: broadcast on chain and continue only if success
      // TODO: broadcast on chain and continue only if success
      // TODO: broadcast on chain and continue only if success
      addMsg(fullMsg, { id: 'user-msg' });
      sendPhotonEvent(3, { msg: fullMsg });
      setInputValue('');
    }
  };

  const allMessages = uiMessages.map((txt = '', id) => {
    if (txt.startsWith(REMATCH_MSG_PREFIX) && !opponentMissing.current) {
      opponentMissing.current = true;
    }
    return (
      <li
        key={`${id}-${txt.substring(0, 10)}`}
        className={msgClassnames(txt)}
      >
        {formattedMsg(txt)}
      </li>
    );
  });

  return (
    <div className="logs">
      <div id="title">JOURNAL</div>

      <div id="terminal-logs" ref={logsRef}>
        <ul>
          {allMessages}
        </ul>
      </div>

      <div id="send-message-container">
        <div className="input-container">
          <input
            className="user-input"
            value={inputValue}
            onChange={(ev) => setInputValue(ev.target.value)}
            onKeyDown={(ev) => ev.key === 'Enter' && sendMessage()}
          />
          <button
            id="send-msg"
            disabled={opponentMissing.current}
            onClick={sendMessage}
          >
            &gt;
          </button>
        </div>
        <p className="chain-warning">
          <span className="warning-icon">⚠️</span>
          &nbsp;Messages stored forever on-chain
        </p>
      </div>
    </div>
  );
};
